import { Link } from 'react-router-dom';
import { AiOutlineArrowRight } from 'react-icons/ai';

const HomePage = () => {
  const sections = [
    {
      title: 'Me',
      description: 'If you really want to know.',
      path: '/about',
    },
    {
      title: 'Thoughts',
      description: "Such as they are.",
      path: '/blog',
    },
    {
      title: 'Day Job',
      description: 'I mean... gotta make a living.',
      path: '/professional',
    },
  ] as const;

  return (
    <div className="min-h-[calc(100vh-10rem)] flex items-center">
      <section className="w-full py-16 md:py-24">
        <div className="mx-auto max-w-4xl rounded-[2rem] border border-[color:var(--wf-border)]/90 bg-[linear-gradient(180deg,rgba(251,246,238,0.95),rgba(243,233,218,0.92))] px-6 py-12 shadow-[0_30px_80px_rgba(20,12,8,0.28)] backdrop-blur-sm sm:px-10 md:px-14 md:py-16">
          <div>
            <h1 className="font-serif text-[clamp(2.1rem,4.3vw,3.35rem)] leading-[1.06] text-[color:var(--wf-ink)] md:whitespace-nowrap">
              Oh. Hey. You're here.
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-7 text-[color:var(--wf-ink-soft)] md:text-lg">
              You're welcome to hang out. Just... don't trip over anything.
            </p>
          </div>

          <div className="my-10 h-px w-full bg-gradient-to-r from-[#a68455] via-[#7a647c]/50 to-transparent" />

          <div className="grid gap-4 md:grid-cols-3">
            {sections.map((section) => (
              <Link
                key={section.path}
                to={section.path}
                className="group rounded-[1.5rem] border border-[color:var(--wf-border)] bg-[linear-gradient(180deg,rgba(246,239,229,0.82),rgba(243,233,218,0.76))] px-5 py-5 transition-all duration-300 hover:-translate-y-1 hover:border-[color:var(--wf-brass)]/60 hover:bg-[linear-gradient(180deg,rgba(248,242,234,0.96),rgba(243,233,218,0.9))] hover:shadow-[0_18px_40px_rgba(20,12,8,0.2)]"
              >
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h2 className="font-serif text-2xl text-[color:var(--wf-ink)] transition-colors duration-300 group-hover:text-[color:var(--wf-plum)]">
                      {section.title}
                    </h2>
                    <p className="mt-3 text-sm leading-6 text-[color:var(--wf-ink-soft)]">
                      {section.description}
                    </p>
                  </div>
                  <AiOutlineArrowRight className="mt-1 shrink-0 text-lg text-[color:var(--wf-plum-soft)] transition-transform duration-300 group-hover:translate-x-1" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
